import {TermsOfService} from "../components/Disclaimers/TermsOfService";

export const TermsOfServicePage = () => {
    return <TermsOfService/>
};